/* eslint-disable camelcase */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-undef */
/* eslint-disable indent */
import React, { useState, useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  Document,
  Page,
  View,
  Text,
  Link,
  Font,
  StyleSheet,
  PDFViewer,
  Image,
  PDFDownloadLink
} from '@react-pdf/renderer'
import RobotoRegular from 'url:./fonts/Roboto/Roboto-Regular.ttf'
import RobotoItalic from 'url:./fonts/Roboto/Roboto-Italic.ttf'
import RobotoSemiBold from 'url:./fonts/Roboto/Roboto-Bold.ttf'
import { themeConfig } from '../../config/theme.config'
import { modalTiers, roadwayVariables } from '../../config/generalInputs.config'

import {
  PEDESTRIAN,
  BICYCLE,
  TRANSIT,
  AUTO,
  FREIGHT
} from '../../constants/modalTiers'
import Header from './Header'
import Scores from './Scores'
import SectionTitle from './SectionTitle'
import ScoringModal from './ScoringModal'
import WeakestLinkVariables from './WeakestLinkVariables'
import ObjectivesMatrix from './ObjectivesMatrix'
import SafetyMeasuresTable from './safetyMeasuresTable'
import ScoresDescriptionContent from './ScoresDescriptionContent'
import ObjectivesMatrixContent from './ObjectivesMatrixContent'

// Register font
Font.register({
  family: 'Roboto',
  fonts: [
    { src: RobotoRegular },
    { src: RobotoSemiBold, fontWeight: 'bold' },
    { src: RobotoItalic, fontStyle: 'italic' }
  ]
})

Font.registerHyphenationCallback((word) => {
  const middle = Math.floor(word.length / 2)
  const part2 =
    word.substring(middle, word.length).length > middle
      ? [
          word.substring(middle, middle + middle),
          word.substring(middle + middle)
        ]
      : [word.substring(middle)]
  const parts =
    word.length === 1 ? [word] : [word.substring(0, middle), ...part2]
  return parts
})

const styles = StyleSheet.create({
  page: { height: 1000 },
  page1: {
    display: 'flex',
    margin: '15pt',
    marginLeft: '20pt',
    marginRight: '20pt'
  },
  container: {
    display: 'flex',
    flexDirection: 'row'
  },
  scoresContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignContent: 'center',
    flexDirection: 'row',
    padding: '10pt',
    height: 300,
    backgroundColor: '#EFEFEF'
  },
  safetyMeasuresContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignContent: 'center',
    flexDirection: 'row',
    padding: '10pt',
    gap: 10
  },
  weakestVariableContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignContent: 'center',
    flexDirection: 'row',
    padding: '5pt',
    height: 220,
    gap: 10
  },
  coverWrapper2: {
    display: 'flex',
    flexDirection: 'row'
  },
  body: {
    margin: '5pt',
    flex: 1,
    flexDirection: 'column',
    alignItems: 'flex-start'
  },
  streetmixImage: {
    height: 200,
    // width: '100%',
    alignSelf: 'center'
  },
  note: {
    padding: '6pt'
    // fontSize: config.themeConfig.textFontSize
  }
})

export default function ReportPage() {
  const dispatch = useDispatch()
  const {
    downloadDataUrl,
    reportHeaderDataUrl,
    reportTickImgDataUrl,
    reportPedestrialImgUrl,
    reportBicycleImgUrl,
    reportAutoImgUrl,
    reportTransitImgUrl,
    reportFreightImgUrl
  } = useSelector((state) => state.appSlice)
  const {
    pedestrian: pedestrianScore,
    transit: transitScore,
    auto: autoScore,
    freight: freightScore,
    bicycle: bicycleScore
  } = useSelector((state) => state.finalScores)

  const {
    pedestrian: pedestrianWeakestLinkScore,
    transit: transitWeakestLinkScore,
    auto: autoWeakestLinkScore,
    freight: freightWeakestLinkScore,
    bicycle: bicycleWeakestLinkScore
  } = useSelector((state) => state.weakestLinkScores)

  const {
    pedestrian: pedestrianWeakestLinkVariable,
    transit: transitWeakestLinkVariable,
    auto: autoWeakestLinkVariable,
    freight: freightWeakestLinkVariable,
    bicycle: bicycleWeakestLinkVariable
  } = useSelector((state) => state.weakestLinkVariables)

  const {
    Pedestrian: pedestrianTier,
    Transit: transitTier,
    Auto: autoTier,
    Freight: freightTier,
    Bicycle: bicycleTier
  } = useSelector((state) => state.modalTiers)

  const { modalPrioritization } = useSelector((state) => state)
  const { safetyMeasuresArr } = useSelector((state) => state.safetyMeasures)
  // eslint-disable-next-line no-useless-rename
  const { land_use_context: landUseContext } = useSelector(
    (state) => state.roadwayVariables
  )

  const [allTiers, setAllTiers] = useState(null)
  const [allScores, setAllScores] = useState(null)
  const [allWeakestVariables, setAllWeakestVariables] = useState(null)
  const [allWeaskestScores, setAllWeaskestScores] = useState(null)

  useEffect(() => {
    setAllTiers({
      pedestrianTier,
      transitTier,
      autoTier,
      freightTier,
      bicycleTier
    })
  }, [pedestrianTier, transitTier, autoTier, freightTier, bicycleTier])

  useEffect(() => {
    setAllWeakestVariables({
      pedestrianWeakestLinkVariable,
      transitWeakestLinkVariable,
      autoWeakestLinkVariable,
      freightWeakestLinkVariable,
      bicycleWeakestLinkVariable
    })
  }, [
    pedestrianWeakestLinkVariable,
    transitWeakestLinkVariable,
    autoWeakestLinkVariable,
    freightWeakestLinkVariable,
    bicycleWeakestLinkVariable
  ])

  useEffect(() => {
    setAllWeaskestScores({
      pedestrianWeakestLinkScore,
      transitWeakestLinkScore,
      autoWeakestLinkScore,
      freightWeakestLinkScore,
      bicycleWeakestLinkScore
    })
  }, [
    pedestrianWeakestLinkScore,
    transitWeakestLinkScore,
    autoWeakestLinkScore,
    freightWeakestLinkScore,
    bicycleWeakestLinkScore
  ])
  useEffect(() => {
    setAllScores({
      pedestrianScore,
      transitScore,
      autoScore,
      freightScore,
      bicycleScore
    })
  }, [pedestrianScore, transitScore, autoScore, freightScore, bicycleScore])
  const isReady =
    !!downloadDataUrl &&
    !!reportHeaderDataUrl &&
    typeof landUseContext === 'string' &&
    landUseContext.trim().length > 0 &&
    Array.isArray(safetyMeasuresArr) &&
    safetyMeasuresArr.length > 0 &&
    modalPrioritization &&
    allTiers &&
    allScores &&
    allWeakestVariables &&
    allWeaskestScores

  if (!isReady) {
    return null // DO NOT RENDER PDF YET
  }

  return (
    <>
      {downloadDataUrl &&
        reportHeaderDataUrl &&
        reportTickImgDataUrl &&
        reportPedestrialImgUrl &&
        reportBicycleImgUrl &&
        reportAutoImgUrl &&
        reportTransitImgUrl &&
        reportFreightImgUrl &&
        typeof landUseContext === 'string' &&
        landUseContext.trim() !== '' && (
          <PDFViewer height="100%" width="100%">
            {allTiers &&
              reportHeaderDataUrl &&
              allScores &&
              allWeakestVariables &&
              allWeaskestScores &&
              downloadDataUrl &&
              typeof landUseContext === 'string' &&
              landUseContext.trim() !== '' &&
              generatePDFDocument(
                allTiers,
                allScores,
                allWeakestVariables,
                allWeaskestScores,
                downloadDataUrl,
                landUseContext,
                safetyMeasuresArr,
                modalPrioritization,
                reportHeaderDataUrl,
                reportTickImgDataUrl,
                reportPedestrialImgUrl,
                reportBicycleImgUrl,
                reportAutoImgUrl,
                reportTransitImgUrl,
                reportFreightImgUrl
              )}
          </PDFViewer>
        )}
    </>
  )
}
export function generatePDFDocument(
  allTiers,
  allScores,
  allWeakestVariables,
  allWeaskestScores,
  downloadDataUrl,
  landUseContext,
  safetyMeasuresArr,
  modalPrioritization,
  reportHeaderDataUrl,
  reportTickImgDataUrl,
  reportPedestrialImgUrl,
  reportBicycleImgUrl,
  reportAutoImgUrl,
  reportTransitImgUrl,
  reportFreightImgUrl
) {
  const { pedestrianTier, transitTier, autoTier, freightTier, bicycleTier } =
    allTiers
  const {
    pedestrianScore,
    transitScore,
    autoScore,
    freightScore,
    bicycleScore
  } = allScores
  const {
    pedestrianWeakestLinkVariable,
    transitWeakestLinkVariable,
    autoWeakestLinkVariable,
    freightWeakestLinkVariable,
    bicycleWeakestLinkVariable
  } = allWeakestVariables
  const {
    pedestrianWeakestLinkScore,
    transitWeakestLinkScore,
    autoWeakestLinkScore,
    freightWeakestLinkScore,
    bicycleWeakestLinkScore
  } = allWeaskestScores
  function getScore(travellerType) {
    switch (travellerType) {
      case PEDESTRIAN:
        return pedestrianScore
      case BICYCLE:
        return bicycleScore

      case TRANSIT:
        return transitScore
      case AUTO:
        return autoScore
      case FREIGHT:
        return freightScore
      default:
    }
  }

  function getWeakestLinkVariables(travellerType) {
    switch (travellerType) {
      case PEDESTRIAN:
        return pedestrianWeakestLinkVariable
      case BICYCLE:
        return bicycleWeakestLinkVariable

      case TRANSIT:
        return transitWeakestLinkVariable
      case AUTO:
        return autoWeakestLinkVariable
      case FREIGHT:
        return freightWeakestLinkVariable
      default:
    }
  }

  function getWeakestLinkScore(travellerType) {
    switch (travellerType) {
      case PEDESTRIAN:
        return pedestrianWeakestLinkScore
      case BICYCLE:
        return bicycleWeakestLinkScore

      case TRANSIT:
        return transitWeakestLinkScore
      case AUTO:
        return autoWeakestLinkScore
      case FREIGHT:
        return freightWeakestLinkScore
      default:
    }
  }

  function getTier(travellerType) {
    switch (travellerType) {
      case PEDESTRIAN:
        return pedestrianTier
      case BICYCLE:
        return bicycleTier

      case TRANSIT:
        return transitTier
      case AUTO:
        return autoTier
      case FREIGHT:
        return freightTier
      default:
    }
  }

  function getPriority(travellerType) {
    if (!modalPrioritization) return
    const priorityIndex = Object.values(modalPrioritization)
      .map((val, index) => {
        if (val === travellerType) {
          return index
        } else {
          return null
        }
      })
      .filter((val) => val !== null)[0]
    const priority = Object.keys(modalPrioritization)[priorityIndex]
    return priority?.slice(-1)
  }

  return (
    <Document>
      <Page size="A4" style={styles.page} orientation="landscape" wrap={true}>
        <Header
          mainColor={themeConfig.semcogBlue1}
          reportHeaderDataUrl={reportHeaderDataUrl}
        />

        <View style={styles.page1}>
          <View
            style={{
              display: 'flex',
              gap: 10
            }}
          >
            <Image
              src={downloadDataUrl}
              style={styles.streetmixImage}
              debug={false}
            />
            <View style={styles.scoresContainer} debug={false} fixed={true}>
              <View
                style={{
                  width: '48%',
                  height: '100%',
                  display: 'flex',
                  alignContent: 'center',
                  alignItems: 'center'
                }}
              >
                <SectionTitle sectionTitle="Average Score" alignSelf="left" />
                <Text
                  style={{
                    fontSize: 10,
                    // color: themeConfig.semcogLightGray,
                    fontFamily: 'Roboto',
                    lineHeight: 1.5
                  }}
                >
                  Each street user’s average score of all their elements
                  determines their overall score.
                </Text>
                <View
                  style={{
                    width: '100%',
                    height: '100%',
                    display: 'flex',
                    alignContent: 'flex-start',
                    alignItems: 'flex-start',
                    flexDirection: 'row',
                    justifyContent: 'space-between',

                    paddingTop: '12pt'
                  }}
                >
                  {modalTiers.map((tier) => {
                    const avgScore = getScore(tier.name)
                    const modalTier = getTier(tier.name)
                    const priority = getPriority(tier.name)

                    return (
                      <ScoringModal
                        key={`${tier.name}-scoring`}
                        name={tier.name}
                        tierId={tier.id}
                        avgScore={avgScore}
                        modalTier={modalTier}
                        priority={priority}
                        reportPedestrialImgUrl={reportPedestrialImgUrl}
                        reportBicycleImgUrl={reportBicycleImgUrl}
                        reportAutoImgUrl={reportAutoImgUrl}
                        reportTransitImgUrl={reportTransitImgUrl}
                        reportFreightImgUrl={reportFreightImgUrl}
                      />
                    )
                  })}
                </View>
              </View>
              <View
                style={{
                  width: '1%',
                  height: '100%',
                  borderLeft: '1pt',
                  borderColor: themeConfig.semcogLightGray,
                  borderLeftWidth: 1
                }}
              />
              <View
                style={{
                  width: '48%',
                  height: '100%',
                  display: 'flex',
                  alignContent: 'center',
                  alignItems: 'center'
                }}
              >
                <SectionTitle sectionTitle="Weakest Link" alignSelf="left" />
                <Text
                  style={{
                    fontSize: 10,
                    fontFamily: 'Roboto',
                    lineHeight: 1.5
                  }}
                >
                  Each street user’s lowest-scoring element determines their
                  overall score.
                </Text>
                <View
                  style={{
                    width: '100%',
                    height: '100%',
                    display: 'flex',
                    alignContent: 'flex-start',
                    alignItems: 'flex-start',
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    paddingTop: '12pt'
                  }}
                >
                  {modalTiers.map((tier) => {
                    const weakestLinkScore = getWeakestLinkScore(tier.name)
                    const modalTier = getTier(tier.name)
                    const priority = getPriority(tier.name)

                    return (
                      <ScoringModal
                        key={`${tier.name}-scoring`}
                        name={tier.name}
                        tierId={tier.id}
                        modalTier={modalTier}
                        priority={priority}
                        weakestLinkScore={weakestLinkScore}
                        landUseContext={landUseContext}
                        reportPedestrialImgUrl={reportPedestrialImgUrl}
                        reportBicycleImgUrl={reportBicycleImgUrl}
                        reportAutoImgUrl={reportAutoImgUrl}
                        reportTransitImgUrl={reportTransitImgUrl}
                        reportFreightImgUrl={reportFreightImgUrl}
                      />
                    )
                  })}
                </View>
              </View>
            </View>
          </View>
        </View>
      </Page>
      <Page size="A4" style={styles.page} orientation="landscape" wrap={true}>
        <Header
          mainColor={themeConfig.semcogBlue1}
          reportHeaderDataUrl={reportHeaderDataUrl}
        />
        <View style={styles.page1}>
          <View
            style={styles.weakestVariableContainer}
            debug={false}
            fixed={true}
          >
            {/* <ScoresDescriptionContent /> */}
            <View
              style={{
                width: '100%',
                height: '100%',
                display: 'flex',
                alignContent: 'center',
                alignItems: 'center',
                // backgroundColor: '#EFEFEF',
                paddingTop: '10pt'
              }}
            >
              <SectionTitle sectionTitle="Which Elements Are the Weakest Links?" />
              <View
                style={{
                  width: '90%',
                  height: '100%',
                  display: 'flex',
                  alignContent: 'flex-start',
                  justifyContent: 'center',

                  flexDirection: 'row',
                  gap: 10
                }}
              >
                {modalTiers.map((tier) => {
                  const weakestLinkVariables = getWeakestLinkVariables(
                    tier.name
                  )
                  const weakestLinkScore = getWeakestLinkScore(tier.name)

                  return (
                    <WeakestLinkVariables
                      key={`${tier.name}-scoring`}
                      name={tier.name}
                      weakestLinkVariables={weakestLinkVariables}
                      weakestLinkScore={weakestLinkScore}
                      reportPedestrialImgUrl={reportPedestrialImgUrl}
                      reportBicycleImgUrl={reportBicycleImgUrl}
                      reportAutoImgUrl={reportAutoImgUrl}
                      reportTransitImgUrl={reportTransitImgUrl}
                      reportFreightImgUrl={reportFreightImgUrl}
                    />
                  )
                })}
              </View>
            </View>
          </View>
        </View>
      </Page>
      <Page size="A4" style={styles.page} orientation="landscape" wrap={true}>
        <Header
          mainColor={themeConfig.semcogBlue1}
          reportHeaderDataUrl={reportHeaderDataUrl}
        />
        <View style={styles.page1}>
          <View style={{ marginTop: '5pt' }}>
            <SectionTitle
              sectionTitle="Understanding Your Score"
              alignSelf="left"
            />
            <Text
              style={{
                fontSize: 10,

                fontFamily: 'Roboto',
                lineHeight: 1.5
              }}
            >
              Land use contexts with lots of activity and lots of different
              types of road users, like Main Street, Urban or Walkable
              Thoroughfares, Small Town Hamlet or Village Commercial, and
              Suburban Corridors, need a score of 1 or 2 to create a safe and
              welcoming environment for all street users. Rural environments
              with less activity need a score of 1, 2, or 3 to satisfy this
              objective.
            </Text>
            <ObjectivesMatrix reportTickImgDataUrl={reportTickImgDataUrl} />
          </View>
        </View>
      </Page>
      <Page size="A4" style={styles.page} orientation="landscape" wrap={true}>
        <Header
          mainColor={themeConfig.semcogBlue1}
          reportHeaderDataUrl={reportHeaderDataUrl}
        />
        <View style={styles.page1}>
          <View
            style={styles.safetyMeasuresContainer}
            debug={false}
            fixed={true}
          >
            <View
              style={{
                width: '62%',

                display: 'flex',
                alignContent: 'center',
                alignItems: 'center'
              }}
            >
              <SectionTitle
                sectionTitle="FHWA Proven Safety Countermeasures Implemented in Your Project"
                alignSelf="left"
              />
              <SafetyMeasuresTable
                safetyMeasuresArr={safetyMeasuresArr}
                reportTickImgDataUrl={reportTickImgDataUrl}
              />
            </View>
            <View
              style={{
                width: '36%',
                height: '100%',
                display: 'flex',
                alignContent: 'center',
                alignItems: 'center'
              }}
            >
              <ObjectivesMatrixContent />
            </View>
          </View>
        </View>
      </Page>
    </Document>
  )
}
